export enum ActionEvents {
  OnboardingLogin = 'app_onboarding_log_in',
  OnboardingLifeAreasSubmit = 'onboarding_funnel_1_life_area_v1_submit',
  OnboardingGoalsSubmit = 'onboarding_funnel_1_create_goals_v1_submit',
  OnboardingGoalsSuggestionClicked = 'onboarding_funnel_1_create_goals_v2_examples_clicked',
  OnboardingHabitsSubmit = 'onboarding_funnel_1_create_habits_v1_submit',
  OnboardingTasksSubmit = 'onboarding_funnel_1_create_tasks_v1_submit',
  OnboardingWorkSituationSubmit = 'onboarding_funnel_1_work_situation_v1_submit',
  OnboardingHearAboutSubmit = 'onboarding_funnel_1_hear_about_us_v1_submit',
  OnboardingPremiumTrialSubmit = 'onboarding_funnel_1_premium_trial_start_button_clicked',
  OnboardingPremiumSkipSubmit = 'onboarding_funnel_1_premium_skip_button_clicked',
  TaskComplete = 'task_complete',
  HabitComplete = 'habit_completed',
  TaskDelete = 'task_delete',
  TaskCreate = 'task_create',
  TagCreate = 'tag_create',
  TagDelete = 'tag_delete',
  GoalComplete = 'goal_complete',
  GoalDelete = 'goal_delete',
  GoalCreate = 'goal_create',
  GoalEdit = 'goal_edit',
  GoalProgressUpdated = 'goal_progress_updated',
  SubGoalCreate = 'subgoal_create',
  SubGoalEdit = 'subgoal_edit',
  SearchResultClicked = 'search_result_clicked',
  LifeAreaCreate = 'life_area_create',
  LifeAreaDelete = 'life_area_delete',
  LifeAreaArchive = 'life_area_archive',
  CancelSubscription = 'cancel_subscription_clicked',
  ShareFeedback = 'share_feedback',
  VisionCreate = 'vision_create',
  VisionEdit = 'vision_edit',
  PushNotificationUpdated = 'push_notifications_updated',
  InitialPushNotificationsQuestion = 'push_notifications_disabled_open_settings',
}
